export type WorkerType = 'Daily Worker' | 'Mason' | 'Carpenter' | 'Painter' | 'Machine Operator' | 'Driver' | 'Foreman' | 'Assistant Foreman' | 'Electrician' | 'Plumber' | 'Welder' | 'Steel Fixer' | 'Tiler' | 'Others';
export type WorkerStatus = 'active' | 'on-leave' | 'off' | 'suspended' | 'inactive' | 'fired';
export type SiteStatus = 'active' | 'on-hold' | 'completed' | 'planned';
export type AttendanceStatus = 'present' | 'absent' | 'late';
export type PaymentStatus = 'paid' | 'pending' | 'partial';

export interface Site {
  id: string;
  name: string;
  location: string;
  status: SiteStatus;
  startDate: string;
  endDate: string | null;
  manager: string;
  workerCount: number;
  description: string;
  contractValue: number;
}

export interface Worker {
  id: string;
  firstName: string;
  lastName: string;
  type: WorkerType;
  status: WorkerStatus;
  siteId: string;
  siteName: string;
  payRate: number;
  payPeriod: 'daily' | 'hourly';
  hourlyRate?: number;
  phone: string;
  email: string;
  idNumber: string;
  bio: string;
  joinDate: string;
  emergencyContact: string;
  emergencyPhone: string;
  photoUrl: string;
  bloodType?: string;
}

export interface AttendanceRecord {
  id: string;
  workerId: string;
  workerName: string;
  workerType: WorkerType;
  siteId: string;
  siteName: string;
  date: string;
  checkInTime: string | null;
  status: AttendanceStatus;
  scannedBy: string;
  method: 'QR Scan' | 'Manual';
}

export interface PaymentRecord {
  id: string;
  workerId: string;
  workerName: string;
  workerType: WorkerType;
  siteId: string;
  siteName: string;
  payRate: number;
  payPeriod: 'daily' | 'hourly';
  hourlyRate?: number;
  daysWorked: number;
  hoursWorked: number;
  grossPay: number;
  deductions: number;
  deductionNote?: string;
  bonus: number;
  bonusNote?: string;
  overtime: number;
  overtimeNote?: string;
  netPay: number;
  status: PaymentStatus;
  periodStart: string;
  periodEnd: string;
  paidOn: string | null;
}

// All static data removed — all data is fetched from the database
export const mockSites: Site[] = [];
export const mockWorkers: Worker[] = [];
export const mockAttendance: AttendanceRecord[] = [];
export const mockPayments: PaymentRecord[] = [];
export const attendanceChartData = [];
export const workerTypeData = [
  { name: 'Mason', value: 0, color: '#D97706' },
  { name: 'Carpenter', value: 0, color: '#1E293B' },
  { name: 'Daily Worker', value: 0, color: '#64748B' },
  { name: 'Others', value: 0, color: '#F59E0B' },
];
function getWorkers(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: getWorkers is not implemented yet.', args);
  return null;
}

export { getWorkers };